import { render, staticRenderFns } from "./assessmentShow.vue?vue&type=template&id=2d8c120d&scoped=true"
import script from "./assessmentShow.vue?vue&type=script&lang=js"
export * from "./assessmentShow.vue?vue&type=script&lang=js"
import style0 from "./assessmentShow.vue?vue&type=style&index=0&id=2d8c120d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c120d",
  null
  
)

export default component.exports